const DEFAULT_PAGE_SIZE = 25;
const DEAL_TYPES = {
  EQUITY: 'Equity',
  DEBT: 'Debt',
}

const OFFER_STATUSES = {
  DRAFT: "draft",
  OFFER_CREATED: "offering_created",
  ESCROW_AGREEMENT_CREATED: "escrow_agreement_created",
  ESCROW_AGREEMENT_SIGNED: "escrow_agreement_signed",
  TECH_SERVICE_AGREEMENT_CREATED: "tech_services_agreement_created",
  ESCROW_SERVICE_AGREEMENT_CREATED: "escrow_service_application_created",
  PENDING_ESCROW: "pending_escrow",
  PAUSED: "paused",
  OPEN: "open",
  LIVE: "live",
  CLOSED: "closed",
  INACTIVE: "inactive"
}

const AFFILIATION_LABELS = [
  {label: 'Employee', value: 'employee'},
  {label: 'Issuer', value: 'issuer'},
  {label: 'Founder', value: 'founder'},
  {label: 'Investor', value: 'investor'},
  {label: 'Promoter', value: 'promoter'},
  {label: 'Affiliate', value: 'affiliate'},
]

const STATES = [
  { 'label': 'Alabama', 'value': 'AL' },
  { 'label': 'Alaska', 'value': 'AK' },
  { 'label': 'American Samoa', 'value': 'AS' },
  { 'label': 'Arizona', 'value': 'AZ' },
  { 'label': 'Arkansas', 'value': 'AR' },
  { 'label': 'California', 'value': 'CA' },
  { 'label': 'Colorado', 'value': 'CO' },
  { 'label': 'Connecticut', 'value': 'CT' },
  { 'label': 'Delaware', 'value': 'DE' },
  { 'label': 'District of Columbia', 'value': 'DC' },
  { 'label': 'Florida', 'value': 'FL' },
  { 'label': 'Georgia', 'value': 'GA' },
  { 'label': 'Guam', 'value': 'GU' },
  { 'label': 'Hawaii', 'value': 'HI' },
  { 'label': 'Idaho', 'value': 'ID' },
  { 'label': 'Illinois', 'value': 'IL' },
  { 'label': 'Indiana', 'value': 'IN' },
  { 'label': 'Iowa', 'value': 'IA' },
  { 'label': 'Kansas', 'value': 'KS' },
  { 'label': 'Kentucky', 'value': 'KY' },
  { 'label': 'Louisiana', 'value': 'LA' },
  { 'label': 'Maine', 'value': 'ME' },
  { 'label': 'Maryland', 'value': 'MD' },
  { 'label': 'Massachusetts', 'value': 'MA' },
  { 'label': 'Michigan', 'value': 'MI' },
  { 'label': 'Minnesota', 'value': 'MN' },
  { 'label': 'Mississippi', 'value': 'MS' },
  { 'label': 'Missouri', 'value': 'MO' },
  { 'label': 'Montana', 'value': 'MT' },
  { 'label': 'Nebraska', 'value': 'NE' },
  { 'label': 'Nevada', 'value': 'NV' },
  { 'label': 'New Hampshire', 'value': 'NH' },
  { 'label': 'New Jersey', 'value': 'NJ' },
  { 'label': 'New Mexico', 'value': 'NM' },
  { 'label': 'New York', 'value': 'NY' },
  { 'label': 'North Carolina', 'value': 'NC' },
  { 'label': 'North Dakota', 'value': 'ND' },
  { 'label': 'Northern Mariana Islands', 'value': 'MP' },
  { 'label': 'Ohio', 'value': 'OH' },
  { 'label': 'Oklahoma', 'value': 'OK' },
  { 'label': 'Oregon', 'value': 'OR' },
  { 'label': 'Pennsylvania', 'value': 'PA' },
  { 'label': 'Peurto Rico', 'value': 'PR' },
  { 'label': 'Rhode Island', 'value': 'RI' },
  { 'label': 'South Carolina', 'value': 'SC' },
  { 'label': 'South Dakota', 'value': 'SD' },
  { 'label': 'Tennessee', 'value': 'TN' },
  { 'label': 'Texas', 'value': 'TX' },
  { 'label': 'Utah', 'value': 'UT' },
  { 'label': 'U.S. Virgin Islands', 'value': 'VI' },
  { 'label': 'Vermont', 'value': 'VT' },
  { 'label': 'Virginia', 'value': 'VA' },
  { 'label': 'Washington', 'value': 'WA' },
  { 'label': 'West Virginia', 'value': 'WV' },
  { 'label': 'Wisconsin', 'value': 'WI' },
  { 'label': 'Wyoming', 'value': 'WY' }
];

function getAbbrFromStateName(state) {
  const _state = STATES.find(state => state.label === state)
  if (_state) return _state.value;
  else return null;
}

function getStateNameFromAbbr(abbr) {
  const state = STATES.find(state => state.value === abbr)
  if (state) return state.label;
  else return null;
}

export {
  DEFAULT_PAGE_SIZE,
  DEAL_TYPES,
  OFFER_STATUSES,
  AFFILIATION_LABELS,
  STATES,
  getStateNameFromAbbr,
  getAbbrFromStateName,
}
